export default function IFTrackerPrivacy() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Privacy Policy – IFTracker
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Effective date: <time dateTime="2025-10-11">October 11, 2025</time>
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <p>
            <strong>Cosmovex</strong> built the <strong>IFTracker</strong> app
            as an ad-supported service. This page informs users about our
            policies regarding the collection, use, and disclosure of personal
            data when using our app.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Information We Collect
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Device information, OS version, crash data, and analytics.</li>
            <li>
              Fasting, hydration, and weight logs (locally or in Firebase).
            </li>
            <li>
              Profile info (name, email, photo) if you sign in via Google.
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            How We Use Information
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>To provide and improve IFTracker’s functionality.</li>
            <li>To enable sync and backup features if you choose.</li>
            <li>To show relevant ads and analyze app usage.</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Third-Party Services
          </h2>
          <p>This app uses trusted third-party services including:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Google Play Services</li>
            <li>Firebase Analytics & Crashlytics</li>
            <li>AdMob</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">Your Rights</h2>
          <p>
            You can request deletion of your account and associated data by
            emailing{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            .
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Security</h2>
          <p>
            We use industry-standard security measures, but no electronic
            storage is 100% secure.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Children’s Privacy
          </h2>
          <p>
            IFTracker is not directed at children under 13, and we do not
            knowingly collect their data.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Changes to This Policy
          </h2>
          <p>
            This policy may be updated periodically. Continued use of the app
            after changes means you accept the new policy.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Us</h2>
          <p>
            Contact us at{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>{" "}
            for any privacy-related concerns.
          </p>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex — All rights reserved.
        </footer>
      </section>
    </main>
  );
}
